import { createError } from '@common/neo.tax';
import { useParams } from 'react-router-dom';

export const useRdProjectId = (): string => {
  const { rdProjectId } = useParams();
  if (!rdProjectId) {
    throw createError('UseRdProjectIdError', 'Empty rd project id when using useRdProjectId hook');
  }
  return rdProjectId;
};

// Only use this in a route where rd project id is not required
export const useRdProjectIdOptional = (): string | null => {
  const { rdProjectId } = useParams();
  return rdProjectId ?? null;
};
